import React, { useState, useContext } from "react";
import { Button, Form, Input } from "reactstrap";
import { AuthContext } from "./index";
import * as firebase from "firebase";
import { withRouter } from "react-router-dom";

const Join = ({ history }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setErrors] = useState("");

  const Auth = useContext(AuthContext);
  const handleForm = e => {
    e.preventDefault();

    firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.SESSION)
      .then(() => {
        firebase
          .auth()
          .createUserWithEmailAndPassword(email, password)
          .then(res => {
            console.log(res);
            history.push("/reports");
            if (res.user) Auth.setLoggedIn(true);
          })
          .catch(e => {
            setErrors(e.message);
          });
      });
  };

  const handleGoogleLogin = () => {
    const provider = new firebase.auth.GoogleAuthProvider();

    firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.SESSION)
      .then(() => {
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(result => {
            console.log(result);
            history.push("/reports");
            Auth.setLoggedIn(true);
          })
          .catch(e => setErrors(e.message));
      });
  };

  return (
    <div className="container">
      <div className="col-md-4 justify-content-center offset-md-4">
        <h2>Join</h2>
        <Form onSubmit={e => handleForm(e)}>
          <Input
            value={email}
            onChange={e => setEmail(e.target.value)}
            name="email"
            type="email"
            placeholder="email"
          />
          <Input
            onChange={e => setPassword(e.target.value)}
            name="password"
            value={password}
            type="password"
            placeholder="password"
          />
          <hr />
          <button
            onClick={() => handleGoogleLogin()}
            className="googleBtn"
            type="button"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
              alt="logo"
            />
            Join With Google
          </button>

          <Button type="submit">Join</Button>

          <span>{error}</span>
        </Form>
      </div>
    </div>
  );
};

export default withRouter(Join);
